import { GridColumnIcon } from "@glideapps/glide-data-grid";

export const column = [
  {
    title: "Name",
    id: "name",
    hasMenu: true,
    icon: GridColumnIcon.HeaderString,
  },
  {
    title: "Company",
    id: "company",
    hasMenu: true,
    dataType: "Bubble",
  },
  {
    title: "Age",
    id: "age",
    hasMenu: true,
    dataType: "Number",
  },
  {
    title: "Image dd",
    id: "image",
    key: "image",
    dataType: "Image",
  },
  {
    title: "Email",
    id: "email",
    hasMenu: true,
  },
  {
    title: "Date",
    id: "date",
    hasMenu: true,
    dataType: "DatePicker",
  },
  {
    title: "Phone",
    id: "phone",
  },
  {
    title: "Address",
    id: "address",
  },
  {
    title: "about",
    id: "about",
  },
];
